import { Heading } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import s from './AnonymousResultsHeader.scss';
export const BngResultsTitle = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t('domain_search_gate.bng_results.title'));
};
//# sourceMappingURL=BngResultsTitle.js.map